import React from "react";
import PropTypes from "prop-types";
import {useNavigate} from "react-router-dom";

export function MenuItem(props) {
  const navigate = useNavigate();

  function handleClick() {
    navigate(props.navigateTo);
  }

  return (
    <button onClick={handleClick} className={`account-menu-item${props.isActive ? " is-active" : ""}`}>
      <div className="account-menu-item__glyph-circle">
        <div className={props.glyph}></div>
      </div>
      <span className="account-menu-item__label">{props.title}</span>
    </button>
  );
}

MenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  glyph: PropTypes.string.isRequired,
  navigateTo: PropTypes.string.isRequired,
}
